import React, { Component } from "react";
import { PropTypes } from "prop-types";
import { Button } from "semantic-ui-react";
import { Field } from "formik";

import FormikSemanticInput from "../../forms/formik/FormikSemanticInput.jsx";

class AcceptButton extends Component {
  static propTypes = {
    ctaCopy: PropTypes.string.isRequired,
    placeholderCopy: PropTypes.string.isRequired,
    challengeRequired: PropTypes.bool.isRequired,
    disabled: PropTypes.bool.isRequired,
    violationErrors: PropTypes.object
  };

  static defaultProps = {
    name: "challengeResponse",
    ctaCopy: "Accept",
    placeholderCopy: "Password",
    challengeRequired: true,
    disabled: false
  };

  // -- HANDLERS -- //

  render() {
    const {
      name,
      ctaCopy,
      placeholderCopy,
      challengeRequired,
      disabled,
      onAccept,
      violationErrors
    } = this.props;

    if (challengeRequired === false) {
      return (
        <Button color="green" onClick={onAccept}>
          {ctaCopy}
        </Button>
      );
    }

    return (
      <Field
        name={name}
        placeholder={placeholderCopy}
        action={{
          color: "green",
          content: ctaCopy,
          type: "submit"
        }}
        icon="lock"
        iconPosition="left"
        type="password"
        disabled={disabled}
        apiErrors={violationErrors}
        component={FormikSemanticInput}
      />
    );
  }
}

export default AcceptButton;
